import React from 'react';

const UploadPOD = (props) => {
    const handleClick = (e) => {
        e.stopPropagation();

        if (props.data.is_submitted_pod === 1 || props.disabled) {
            return; // Do nothing if the button is disabled
        }

        props.onClickUploadPOD(props);
    };

    const isDisabled = props.data.is_submitted_pod === 1 || props.disabled;
    const tooltipMessage = props.data.is_submitted_pod === 1 ? "POD already submitted" : "Upload POD";

    return (
        <button
            onClick={handleClick}
            style={{
                border: "none",
                backgroundColor: "transparent",
                opacity: isDisabled ? 0.5 : 1, // Reduce opacity for greyed-out button
                cursor: "pointer", 
            }}
            title={tooltipMessage} // Tooltip message
        >
            <i
                className="icofont icofont-upload f17"
                style={{
                    fontSize: "17px",
                    color: isDisabled ? "grey" : "green", // Change color based on disabled state
                    lineHeight: "1",
                }}
                title={tooltipMessage} // Tooltip message for the icon
            ></i>
        </button>
    );
};

export default UploadPOD;
